module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/long-arrow-right.svg?5bc2f66ddc47c8e99e6609f53051c585";